import { Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/**
 * Flags an ad account Meta will not let spend until a payment method is added.
 * Shared by the integration settings list and the boost launch picker so the
 * same fact reads the same way wherever an ad account is shown.
 */
export function PaymentNeededBadge() {
  const { t } = useTranslation();

  return (
    <Badge size="xs" colorPalette="orange" flexShrink={0}>
      {t('integrations.metaAds.defaultAccount.paymentNeeded')}
    </Badge>
  );
}
